import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { StorageService } from '../../../core/storage/storageService';
import { NavService } from '../../../models/ui/navService';
import { Role } from '../../../models/users/role';
import { RoleService } from '../../../models/users/roleService';
import { UIErrorHandler } from '../../../core/uiErrorHandler';

@Component({
  selector: 'app-edit-role',
  templateUrl: './edit-role.component.html',
  standalone: false,
})
export class EditRoleComponent {
  @Input() set role(value: Partial<Role> | undefined) {
    if (value) {
      this.roleData = Role.copy(value);
      this.refreshDisplay();
    } else {
      this.roleData = undefined;
    }
  }
  @Output() saved = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter();

  roleData: Partial<Role> | undefined = undefined;
  userAccessGrant: string[] = [];
  userAccessRevoke: string[] = [];
  userAccessMap: Map<string, boolean> | undefined = undefined;
  allNamespaces: any[] = [];
  allAccessBitsToCheck: any[] = [];
  accessCategories: string[] = [];
  usedAccessCategories: string[] = [];
  categoryMap = new Array();

  constructor(
    private roleService: RoleService,
    private navService: NavService,
    private uiErrorHandler: UIErrorHandler,
    private changeDetector: ChangeDetectorRef,
  ) {}

  btnSave_click() {
    if (this.roleData && this.roleData.name && this.roleData.accessBits) {
      this.roleService
        .saveRole(
          this.roleData.name,
          this.userAccessGrant,
          this.userAccessRevoke,
        )
        .then((response) => {
          this.roleData = undefined;
          this.userAccessGrant = [];
          this.userAccessRevoke = [];
          this.userAccessMap = undefined;
          this.saved.emit();
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    }
  }

  btnCancel_click() {
    this.roleData = undefined;
    this.userAccessGrant = [];
    this.userAccessRevoke = [];
    this.userAccessMap = undefined;
    this.cancelled.emit();
  }

  chkAccessBit_clicked(event: any, namespace: string) {
    if (event.srcElement.checked) {
      let idx = this.userAccessRevoke.indexOf(namespace);
      if (idx >= 0) {
        this.userAccessRevoke.splice(idx, 1);
      }
      this.userAccessGrant.push(namespace);
    } else {
      let idx = this.userAccessGrant.indexOf(namespace);
      if (idx >= 0) {
        this.userAccessGrant.splice(idx, 1);
      }

      this.userAccessRevoke.push(namespace);
    }
  }

  categoryHasCheckedItems(accessCategory: string): boolean {
    // console.log({ category: accessCategory, categoryMap: this.categoryMap, includes: this.categoryMap.includes(accessCategory), userAccessMap: this.userAccessMap });
    return this.categoryMap.includes(accessCategory);
  }

  refreshDisplay() {
    this.allNamespaces = StorageService.getAllAccessNamespaces();

    const accessBits = this.roleData?.accessBits;
    if (accessBits) {
      this.userAccessMap = this.navService.generateAccessTable(
        this.allNamespaces,
        accessBits,
      );

      this.userAccessGrant = [];
      this.userAccessRevoke = [];

      // We basically have to build the checkbox table from a copy
      // of the namespaces map rather than use the map itself.
      // Otherwise, Angular will hold onto some sort of reference
      // to the checkbox control, and when the form gets reloaded
      // for another user, all of the previous selections will be
      // reinstated, despite the result of [checked]=getChecked().
      // ANNOYING!!!!
      this.accessCategories = [];
      this.usedAccessCategories = [];
      this.allAccessBitsToCheck = [];
      for (let i = 0; i < this.allNamespaces.length; i++) {
        // TODO: ignoring the base-level permissions.
        // Should we get rid of them?

        
        if (
          this.allNamespaces[i].name != 'portal-r' &&
          this.allNamespaces[i].name != 'portal-w'
        ) {
          const { name, category, friendlyName, accessLevelConf } = this.allNamespaces[i];
          if (!this.accessCategories.includes(category)) {
            this.accessCategories.push(category);
            if(!this.usedAccessCategories.includes(category) && this.getChecked(name, category)) {
              this.usedAccessCategories.push(category);
            }
          }
          this.allAccessBitsToCheck.push({ name, category, friendlyName, accessLevelConf })
        }
      }

      this.changeDetector.detectChanges();
    } else {
      this.userAccessMap = new Map<string, boolean>();
    }


    if (this.roleData?.accessBits) {
      this.userAccessMap = this.navService.generateAccessTable(
        this.allNamespaces,
        this.roleData.accessBits,
      );
      for (let i = 0; i < this.allNamespaces.length; i++) {
        if (this.allNamespaces[i].name == 'portal-r') {
          this.allNamespaces.splice(this.allNamespaces[i], 1);
        }
        if (this.allNamespaces[i].name == 'portal-w') {
          this.allNamespaces.splice(this.allNamespaces[i], 1);
        }
      }
    }
  }

  passesValidation(): boolean {
    return true;
  }

  getChecked(namespace: string, category: string): boolean {
    if (this.userAccessMap) {
      let included = this.userAccessMap.get(namespace);

      if (included && !this.categoryMap.includes(category)) {
        this.categoryMap.push(category);
      }

      return included || false;
    }
    return false;
  }

  getPaddingLevels(namespace: string, lastNamespace: any | undefined): number {
    // remove eveything after "-"
    // remove common part of namespace
    // return number of additional segments in current namespace
    /*
    if (lastNamespace) {

      let trimmedCurrent = namespace.substring(0, namespace.indexOf("-"));
      let trimmedLast = lastNamespace.name.substring(0, namespace.indexOf("-"));
 
      if (trimmedCurrent.length == trimmedLast.length) {
        return namespace.split('.').length - 1;
      }

      let t = trimmedCurrent.replace(trimmedLast, "")

      if (t.length < trimmedCurrent.length) {
        // this is a sub-level
        return namespace.split('.').length - 1;
      }

      for (let i=0; i<namespace.length && i<lastNamespace.name.length; i++) {
        if (namespace[i] != lastNamespace.name[i]) {

        }
      }

      console.log(trimmedCurrent, trimmedLast);
    }
    */
    return namespace.split('.').length - 1;
  }
}
